import { render } from "./PractitionerForm.vue?vue&type=template&id=785d1cd3&scoped=true"
import script from "./PractitionerForm.vue?vue&type=script&lang=js"
export * from "./PractitionerForm.vue?vue&type=script&lang=js"

import "./PractitionerForm.vue?vue&type=style&index=0&id=785d1cd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785d1cd3"]])

export default __exports__